import type { Components } from '@mui/material/styles';

import { FONT_STACK } from '../constants/fontface.constant';

export const MuiFormHelperText = (): Partial<Components> => ({
  MuiFormHelperText: {
    styleOverrides: {
      root: {
        fontFamily: FONT_STACK,
        fontSize: '0.7rem',
      },
    },
  },
});
